module.exports = __webpack_public_path__ + "img/PLGM.42df22ca.png";